<template>
    <div class="card-form">
        <span v-if="hasTariffOwner" class="text-grey-800">
            {{ $t('lang.prolongation.has_tariff_owner') }}
        </span>
        <form :action="getActionUrl" method="POST">
            <h3 class="mb-5">{{ getTitle }}</h3>
            <div v-if="this.isCanChangeTariff" class="flex justify-content-between flex-column xl:flex-row">
                <template v-if="!this.isShowForm">
                    <Button :label="getButtonTitle" @click="showForm" text />
                    <Button :label="$t('lang.prolongation.has_promo')" @click="onClickPromo" text />
                </template>
            </div>
            <div v-show="this.isShowForm" id="changePlanPanel">
                <input type="hidden" name="act" value="prolong" />
                <div v-if="this.getCurrUser.isCurrentTariffPayed" class="flex flex-column mb-5">
                    <p class="p-0">{{ $t('lang.prolongation.change_rules') }}</p>
                    <span v-if="this.balanceInDays > 0">
                        {{ $t('lang.prolongation.unused_days_1') }}
                        <b>{{ this.balanceInDays.formatMoney(0, ' ', ' ') }}</b>
                        {{ $t('lang.prolongation.unused_days_2') }}
                    </span>
                </div>
                <TariffSelector
                    v-model:tarif="tarif"
                    v-model:srok="srok"
                    :tariff-percent="tariffPercent"
                    :tariff-templates="tariffTemplates"
                    :is-disabled="isDisabled"
                    :all-prices="getAllPrices"
                    :balance-in-days="balanceInDays"
                    :is-free="isTariffFree"
                />
                <input type="hidden" name="tarif" :value="tarif" />
                <input type="hidden" name="srok" :value="srok" />
                <div class="comment-container" v-if="showComment">
                    <div style="padding-top: 10px" v-html="$t('lang.promotion.text')"></div>
                </div>
                <div class="grid grid-nogutter mt-3">
                    <div v-if="srok === 10" class="col flex align-items-center flex-column sm:flex-row gap-5">
                        <Button class="w-full sm:w-auto" :label="getSubmitButtonTitle" @click="sendUpTariff(tarif)"/>
                    </div>
                    <div v-else class="col flex align-items-center flex-column sm:flex-row gap-5">
                        <span class="text-4xl font-bold">
                                {{ total ?? 0 }}
                                <span :title="$t('lang.main.currency.title')">{{ $t('lang.main.currency.sign') }}</span>
                            </span>
                        <Button :disabled="+total == 0" type="submit" class="w-full sm:w-auto" :label="getSubmitButtonTitle" />
                    </div>
                </div>
                <div class="grid grid-nogutter mt-3">
                    <div class="col-12 flex justify-content-end">
                        <Button :label="$t('lang.prolongation.has_promo')" @click="onClickPromo" text />
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import Calculator, {FREE, TARIFF_BASIC, TARIFFS} from "../modules/Calculator";
import Button from "primevue/button";
import RadioButton from "primevue/radiobutton";
import Badge from "primevue/badge";
import TariffSelector from "./subscription/TariffSelector.vue";
import {Listeners} from "../constants/listeners";
import UserApi from "../api/UserApi";
import Alerts from "../mixins/Alerts";
import animateScrollTo from "animated-scroll-to";

export default {
    name: "Prolong",
    mixins: [Alerts],
    data() {
        return {
            srok: 1,
            tarif: TARIFF_BASIC,
            isShowForm: false,
            discount: "",
            calc: null,
            disabledMap: [],
        };
    },
    props: {
        currentTarif: {
            type: Number,
            required: true,
        },
        realTarif: {
            type: Number,
            required: true,
        },
        balanceInDays: {
            type: Number,
            required: true,
        },
        isPayed: {
            type: Boolean,
            required: true,
        },
        isDemo: {
            type: Boolean,
            required: true,
        },
        tariffTemplates: {
            type: Object,
            required: true,
        },
        tariffPercent: {
            type: Object,
            required: true,
        },
        promotion: {
            type: Boolean,
            required: false,
            default: false
        },
        hasTariffOwner: {
            type: Boolean,
            required: true,
        },
    },
    created() {
        if (this.isPayed) {
            let calc = new Calculator(this.realTarif, this.srok);
            this.tarif = calc.getNext()
        }

        // пришли за тарифом выше текущего (?needleTariff= из окна ограничений) - сразу предлагаем его
        const needleTariff = parseInt(new URLSearchParams(window.location.search).get('needleTariff'));
        if (TARIFFS.includes(needleTariff) && needleTariff > this.realTarif) {
            this.tarif = needleTariff;
            this.isShowForm = true;
        }

        if (window.location.hash === "#changePlanPanel") {
            this.showForm();
        }
    },
    mounted() {
        if (!this.isShowForm && this.realTarif === FREE) {
            this.isShowForm = true
        }
    },
    methods: {
        onClickPromo() {
            this.$emitter.emit(Listeners.PANEL_PROMO_SHOW_ACTIVATE_FORM);
        },
        sendUpTariff(tariffId) {
            this.$emitter.emit(Listeners.GLOBAL_PRELOADER_SHOW);
            UserApi.upTariff(tariffId)
                .then((resp) => {
                    location.reload();
                })
                .catch(error => {
                    this.$emitter.emit(Listeners.GLOBAL_PRELOADER_HIDE)
                    this.alertError(error)
                });
        },
        showForm: function () {
            this.isShowForm = true;
            setTimeout(() => {
                animateScrollTo(document.getElementById('changePlanPanel').getBoundingClientRect().height);
            }, 0);
        },
        isDisabled: function (tariff) {
            if (!this.isPayed || this.isDemo) {
                return false;
            }

            if (!(tariff in this.disabledMap)) {
                let calc = new Calculator(tariff, this.srok);
                this.disabledMap[tariff] = calc.gteThanCurrent(this.realTarif);
            }

            return this.disabledMap[tariff];
        },
    },
    computed: {
        isCanChangeTariff() {
            return this.getCurrUser.currentTariff.realNumber !== Math.max(Object.values(TARIFFS));
        },
        getActionUrl() {
            return sprintf('/%s/panel', window.locale);
        },
        getCurrUser() {
            return this.$store.getters.USER;
        },
        getTitle() {
            return this.isCanChangeTariff && !this.isTariffFree
                ? this.$t('lang.prolongation.change_tariff')
                : this.$t('lang.prolongation.select_tariff');
        },
        getButtonTitle() {
            return this.isCanChangeTariff && !this.isTariffFree
                ? this.$t('lang.prolongation.change_tariff_q')
                : this.$t('lang.prolongation.select_tariff_q');
        },
        getSubmitButtonTitle() {
            return this.getCurrUser.lastPaySumm > 0 && !this.isTariffFree
                ? (this.srok === 10 ? 'Конвертировать' : this.$t('lang.panel.change_btn'))
                : this.$t('lang.panel.buy_btn');
        },
        isTariffFree() {
            return this.realTarif === FREE;
        },
        total: function () {
            let calc = new Calculator(this.tarif, this.srok);
            let amount = 0
            if (!calc.gteThanCurrent(this.currentTarif) && this.balanceInDays > 0) {
                amount = calc.getAmount(this.balanceInDays)
                this.discount = amount.formatMoney(0, ' ', ' ') + ' ₽ - скидка ' + this.balanceInDays.formatMoney(0, ' ', ' ') + ' ₽';
            } else {
                amount = calc.getAmount()
            }

            if (amount <= 100) {
                amount = 100;
            }

            return amount.formatMoney(0, ' ', ' ');
        },
        getAllPrices: function () {
            let calc = new Calculator(this.tarif, this.srok);
            return calc.getAllPrices();
        },
        showComment() {
            return this.promotion;
        },
    },
    components: {
        TariffSelector,
        Button,
        RadioButton,
        Badge,
    }
}
</script>
